<div class="content">
  <app-medical-profile-header [medicalProfile]="medicalProfile()" />
  <div class="list">
    @for (item of items(); track $index) {
      <app-prescription-row [orderStatus]="orderStatus()" (remove)="removeItem($index)" [item]="item" [last]="$last" [simple]="false" [canRemove]="canRemoveItems()" />
    }
  </div>
</div>
